// extracted by mini-css-extract-plugin
var _1 = "CtRQniNISGJ0aXiB5JKV";
export { _1 as "spinner" }
